import React, {Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { convertToRupiah, formatCurrency, formatCurrencyRupiah} from '../../utils';
import { connect } from "react-redux"

class TextRupiah extends Component{
  render(){
    const { ratio, currency: newCurrency, disabled, subsidy, isOffer, isFormatRupiah, isSubsidy, isOnlyKickPoint = false } = this.props
    let currency = isOnlyKickPoint? "KP" : newCurrency;
    return(
      <span 
       style={{ ...this.props.style }}
       className={classnames("currency-tag",
        `currency-tag__${this.props.color}`,
        `text-${this.props.align}`,
        this.props.className,
        {'text-bold': this.props.bold, 'text-block': this.props.block, 'disabled': disabled, 'subsidy': subsidy, "offer": isOffer})}
      >
        {
          this.props.isFormatRupiah ?
          `${this.props.minus} ${formatCurrencyRupiah(this.props.value, ratio, currency)}`
          :
          `${this.props.minus} ${formatCurrency(this.props.value, ratio, currency)}`
        }
      </span>
    )
  }
}
const mapStateToProps = state => ({ 
  ratio: state.dataAuth.userCurrency.ratio,
  currency: state.dataAuth.userCurrency.currency
}) 
export default connect(mapStateToProps)(TextRupiah)

TextRupiah.propTypes={
  bold:PropTypes.bool,
  value:PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  prefix:PropTypes.string,
  align:PropTypes.oneOf(['left', 'right','center']),
  block:PropTypes.bool,
  color: PropTypes.oneOf(['default', 'black', 'red']),
  disabled: PropTypes.bool,
  minus:PropTypes.string,
  subsidy: PropTypes.bool
}

TextRupiah.defaultProps = {
  prefix: 'IDR',
  align:'left',
  className:null,
  color: 'default',
  value: 0,
  disabled: false,
  minus: '',
  subsidy: false
};